import { gsap, ScrollTrigger } from "../layout";

// matchheight
import {matchHeight} from '../matchHeight';

function cardMatchHeight() {
    // latest news match height
    const newsTitle = document.querySelectorAll('.news-card__title');
    matchHeight(newsTitle);
}

function newsFilter() {
    const newsForm = document.querySelector('#news-filter')
    let categorySelect = document.querySelector('#selectCategory');

    if(categorySelect) {
        categorySelect.addEventListener("change", function(event){
            newsForm.submit();
        });
    }
}

function donationSection() {
    const donationSection = document.querySelector(".donation");
    const donationWrapper = document.querySelector(".donation__wrapper");

    let mm = gsap.matchMedia()
    mm.add("(min-width: 1025px)", () => {
        ScrollTrigger.create({
            trigger: donationSection,
            pin: donationWrapper,
            start: "top+=5% top",
            end: "bottom-=13% bottom",
            // markers: true
        });
    })
}

function detailNewsImage() {
    const imageMobileWrapper = document.querySelector('.detail-header__image-mobile-wrapper');
    const imageCol = document.querySelector('.detail-header__image-col');
    const imageContainer = document.querySelector('.detail-header__image-container');

    if(imageCol) {
        if (window.innerWidth < 992) {
            imageMobileWrapper.prepend(imageContainer);
        } else {
            imageCol.append(imageContainer);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    cardMatchHeight();
    newsFilter();
    donationSection();
    detailNewsImage();
})

window.addEventListener('resize', () => {
    cardMatchHeight();
    detailNewsImage();
})